module.exports = __webpack_public_path__ + "static/media/after-effects.5ac6b6ec.svg";